'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('template-edit', {
      url: '/template/edit/:id',
      template: '<template-edit></template-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/template/template-edit/template-edit.routes.js